import { mdiAccountSearchOutline, mdiAccountGroupOutline, mdiTimelineCheckOutline } from '@mdi/js'
import { PRIVATE } from '@/plugins/acl/const'

export default [
  {
    subheader: 'rekrutacja',
    resource: PRIVATE.ATS.JOBS,
    action: 'read',
  },
  {
    title: 'jobs',
    icon: mdiAccountSearchOutline,
    to: 'recruitment-jobs-list',
    resource: PRIVATE.ATS.JOBS,
    action: 'read',
  },
  {
    title: 'candidates',
    icon: mdiAccountGroupOutline,
    to: 'recruitment-candidates-list',
    resource: PRIVATE.ATS.CANDIDATES,
    action: 'read',
    hiddenForAccess: ['coordinator'],
  },
  {
    title: 'processes',
    icon: mdiTimelineCheckOutline,
    to: 'recruitment-processes-list',
    resource: PRIVATE.TEMPLATE.WORKFLOW,
    action: 'read',
  },
]
